import { useState } from 'react'

import { Box, Button, Hidden, Paper, TablePagination } from '@material-ui/core'
import { PlusCircle as PlusCircleIcon } from 'react-feather'

import { Card, LoadingFeedback, Permitted } from 'components'
import {
  OrganizationCompaniesForm,
  OrganizationCompaniesTable,
} from './components'

import { useFetch, usePagination } from 'hooks'
import * as service from 'service'
import permissions from 'constants/permissions'
import constants from 'constants/index'

const OrganizationCompany = ({ organization }) => {
  const [isFormLoading, setIsFormLoading] = useState(false)
  const [openCreateDialog, setOpenCreateDialog] = useState(false)

  const handleOpenCreateDialog = () => setOpenCreateDialog(true)

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination()

  const { response, isLoading, refresh } = useFetch(
    service.backoffice.organizationCompanies.get,
    {
      organizationId: organization?.id,
      params: { page, perPage },
    },
    [organization?.id, page, perPage],
    !!organization?.id,
  )

  const organizationCompanies = response?.data?.organizationCompanies || []

  const isCustomerSuccess =
    organization?.kind === constants.organizations.CUSTOMER_SUCCESS_KIND

  return (
    <Card
      title="Empresas"
      menuButton
      {...(!isCustomerSuccess && {
        actionButton: (
          <Permitted tag={permissions.ORGANIZATION_COMPANY.MANAGE}>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<PlusCircleIcon size={20} />}
              onClick={handleOpenCreateDialog}
            >
              VINCULAR EMPRESA
            </Button>
          </Permitted>
        ),
      })}
    >
      <Paper component={Box}>
        <LoadingFeedback open={isLoading || isFormLoading} />
        <OrganizationCompaniesTable
          organizationCompanies={organizationCompanies}
          organization={organization}
          refresh={refresh}
          showUser
        />
        <TablePagination
          component="div"
          count={response?.data?.meta?.totalCount || 0}
          onPageChange={(_, page) => handleChangePage(page)}
          onRowsPerPageChange={handleChangeRowsPerPage}
          page={page - 1}
          rowsPerPage={perPage}
          rowsPerPageOptions={[5, 10, 25, 100]}
          labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
          nextIconButtonProps={{ size: 'small' }}
          backIconButtonProps={{ size: 'small' }}
        />

        <OrganizationCompaniesForm
          open={openCreateDialog}
          setOpen={setOpenCreateDialog}
          refresh={refresh}
          organization={organization}
          setIsLoading={setIsFormLoading}
        />
      </Paper>
    </Card>
  )
}

export default OrganizationCompany
